import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Case } from '../../../../../_base-shared/models/Case/Case';
import { User } from '../../../../../_base-shared/models/User/User';
import { ScriptLoaderService } from '../../../../../_base-shared/services/script-loader.service';
import { environment } from '../../../environments/environment';
import { ClientGlobalEventService } from '../../_shared/services/client-global-event.service';
import { ClientAppService } from '../../client-app.service';
import { ClientAuthService } from '../../client-auth/client-auth.service';

@Component({
  selector:    'app-nav',
  templateUrl: './nav.component.html',
  styleUrls:   ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  @Input() selectedCase: Case;
  public authUser: User;
  public showNav              = true;
  public navV2                = false;
  public logoDestination: string;
  public isDesktop: boolean;
  public showWhatsAppButton   = false;
  public logoDocumentsVisible = false;
  public isLeadComponent      = false;
  public isMobileNav          = false;

  constructor(private router: Router,
              private breakpointObserver: BreakpointObserver,
              @Inject(DOCUMENT) private document: Document,
              private globalEventsService: ClientGlobalEventService,
              private scriptLoaderService: ScriptLoaderService,
              private clientAppService: ClientAppService,
              private clientAuthService: ClientAuthService,
  ) {
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Large, Breakpoints.XLarge]).subscribe(result => {
      this.isDesktop   = result.matches;
      this.isMobileNav = result.matches;
    });
    if (this.router.url.includes('public/client-lead')) {
      this.showNav = false;
      this.navV2   = false;
      return;
    }
    this.logoDocumentsVisible = this.router.url.includes('public') ? true : false;
    this.logoDestination      = environment.APP_ENV === 'local' ? environment.APP_URL : 'https://www.deudafix.es';
    this.globalEventsService.navStatus$.subscribe(result => this.showNav = result);
    this.breakpointObserver.observe([Breakpoints.Large, Breakpoints.XLarge]).subscribe(result => {
      this.isDesktop = result.matches;
    });
    this.clientAppService.navSubject$.subscribe(isNavV2 => this.navV2 = isNavV2);
    this.showWhatsAppButton = true;
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      this.showWhatsAppButton = event.url === '/';
    });
    this.globalEventsService.authUser$.subscribe(user => this.authUser = user);
  }

  public changeNav(): void {
    this.clientAppService.setNavSubject(false);
    this.clientAppService.navSubject$.subscribe(data => {
      if (!data) {
        this.navV2 = data;
      }
    });
  }

  public logOut(): void {
    this.clientAuthService.logout().subscribe(res => {
      this.globalEventsService.setAuthUser(null);
      this.router.navigateByUrl('/auth/login');
    });
  }
  public openMobileNav(): void {
    this.isMobileNav = !this.isMobileNav;
  }
}
